// extracted by mini-css-extract-plugin
export default {"type__xl":"Caption-module--type__xl--zQob2","type__lg":"Caption-module--type__lg--wXJbU","type__md":"Caption-module--type__md--mqZEG"};